import { render, staticRenderFns } from "./ADescuentoVer.vue?vue&type=template&id=331bcacb"
import script from "./ADescuentoVer.vue?vue&type=script&lang=js"
export * from "./ADescuentoVer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports